<ul class="tag__container container" role="list" *ngIf="items.length">
  <li role="listitem" *ngFor="let tag of items">
    <a [href]="getUrl(tag)" (click)="eventClick(tag)" class="tag__item" role="button" tabindex="0">{{tag}}</a>
  </li>
</ul>